// extracted by mini-css-extract-plugin
export default {"wrapperLoader":"ui_wrapperLoader__7Jsxa","checkSignSuccess":"ui_checkSignSuccess__WjVHU","qrWrapper":"ui_qrWrapper__qeRcb"};